import React from "react";
import { Redo } from "@mui/icons-material";

import { HistoryContext, useHistory } from "fond/history";

import { IButtonProps } from "./Toolbar";
import ToolbarButton from "./ToolbarButton";

const RedoButton: React.FC<IButtonProps> = ({ icon, mode, title = "Redo" }) => {
  const { canRedo, redo } = useHistory(HistoryContext);
  const isDisabled = !canRedo || (!!mode && !["simple_select", "direct_select", "static", "draw_point"].includes(mode));

  const handleOnClick = () => {
    redo();
  };

  return (
    <ToolbarButton title={title} onClick={handleOnClick} disabled={isDisabled} data-testid="toolbar-redo-button">
      {icon || <Redo />}
    </ToolbarButton>
  );
};

export default RedoButton;
